import { InventoryCondition, InventoryItemTypes } from "types";

export const PRIMARY_COLOR = "rgba(39,56,105)";

export const INVENTORY_ITEM_TYPES: InventoryItemTypes[] = [
  "Office Consumables",
  "IT Equipment",
  "Furniture",
  "Others",
];

export const INVENTORY_CONDITIONS: InventoryCondition[] = [
  "New",
  "Used",
  "Damaged",
];

export const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:8058";
export const APP_URL = process.env.REACT_APP_APP_URL ?? "http://localhost:3000";

export const SSO_URL = `${API_URL}/auth/login/microsoft?redirect=${APP_URL}?complete_auth=true`;
